import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const NGW = () => {
    const accordionContent = [
        <div key="1" className="p-4">
            <p>Growth of Internet, Basic internet protocols, History of the Internet, World Wide Web, HTTP: Hypertext
                Transfer Protocol, Markup languages-XHTML, Introduction to HTML, Basics of XTHML, DHTML, and XML
                Anatomy of Internet, APRANET and Internet history of the World Web, Basic Internet Terminology, Internet
                Protocols: TCP/IP, Router, Internet Addressing Scheme, Machine Addressing (IP address), E-mail Address, XML
                versions & declarations, Introduction to WML.</p>
        </div>,
        <div key="2" className="p-4">
            <p>Database Connectivity: JDBC, ODBC, Database-to web connectivity, Web Page, Website and Web Application,
                Technology Framework for development, Client-side scripting: JavaScript, Client Side Programming: JAVA
                Scripts, basic syntax, variables & data-types, literals, functions, objects, arrays and built-in objects, Server side
                programming , Java Servlets, Life cycle, parameter data, sessions, cookies, servlets capabilities, servlets &
                concurrency.</p>
        </div>,
        <div key="3" className="p-4">
            <p>Web attacks and their prevention, Security Threats, Security risks of a site, Session management,
                authentication, HTTPS and certificates, Firewalls (WAFs), Web security model, Client-side security, Cookies
                security policy, HTTP security extensions, Web user tracking, Server-side security tools, Web Application and
                Fuzzers.</p>
        </div>,
        <div key="4" className="p-4">
            <p>Concept and issues of Web 2.0 and Web 3.0, Latest Trends in Web Technologies, Search Engines, Web
                Crawling, Search Engine Optimization, Web Security concerns, Applications of Web Engineering Technologies
                in distributed systems etc, Case studies using different tools, Web IR System, Web Analytics, Web Mining
                Framework, Social Web Mining and Text Mining.</p>
        </div>
    ];

    const tabData = [
        {
            id: 'syllabus',
            label: 'Syllabus',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'notes',
            label: 'Notes',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'important',
            label: 'Important Questions',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'books',
            label: 'Books',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'PYQ',
            label: 'PYQ',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'youtube_playlist',
            label: 'Video Lectures',
            content: null, // Will be replaced in SubjectPage
        },
    ];

    return (
        <SubjectPage
            subjectName="Next Generation Web"
            subjectKey="NGW"
            accordionContent={accordionContent}
            tabData={tabData}
            adminEmail="snaped4338@gmail.com"
            firestoreCollections={{
                notes: 'NGWNotes',
                videos: 'NGWVideos'
            }}
        />
    );
};

export default NGW;